import { render, staticRenderFns } from "./ConditionsText.vue?vue&type=template&id=f4850cec&"
import script from "./ConditionsText.vue?vue&type=script&lang=js&"
export * from "./ConditionsText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports